import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListContractor({
    loading,
    contractors,
    filteredContractors,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Contractor Name</th>
                        <th>Contractor Code</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>PAN</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>District</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="12" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : contractors.length > 0 ? (
                        filteredContractors.map((c) => {
                            const isActive = c.status === "Active";

                            return (
                                <tr key={c.id}>
                                    <td>
                                        {/*Inactive records cannot be selected */}
                                        <input
                                            type="radio"
                                            name="contractorSelect"
                                            disabled={!isActive}
                                            checked={selected?.id === c.id}
                                            onChange={() => handleSelect(c)}
                                        />
                                    </td>

                                    <td>{c.contractorName}</td>
                                    <td>{c.contractorCode}</td>
                                    <td>{c.firstName}</td>
                                    <td>{c.lastName}</td>
                                    <td>{c.emailId}</td>
                                    <td>{c.mobileNo}</td>
                                    <td>{c.PAN}</td>
                                    <td>{c.countryName}</td>
                                    <td>{c.stateName}</td>
                                    <td>{c.cityName}</td>

                                    <td>
                                        <span
                                            className={`badge ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            onClick={() => handleToggleStatus(c)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="12" className="text-center text-muted">
                                No contractors found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
